// extracted by mini-css-extract-plugin
module.exports = {"Section":"Section_Section__2zU51","section-content":"Section_section-content__1dyQr"};